import React from 'react';
import { Card, CardHeader, Table, TableRow, TableHead, TableBody, TableCell } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'react-admin';
import { toDisplayDateTimeFormat } from '../components/helper/DateHelper';
import { useHistory } from 'react-router-dom';

const useStyle = makeStyles({
	root: {
		flex: 1
	},
	tableRow: {
		cursor: 'pointer'
	}
});

const UnprocessedIdDocuments = ({ value = [] }) => {
	const translate = useTranslate();
	const classes = useStyle();
	const history = useHistory();
	return (
		<Card className={classes.root}>
			<CardHeader title={translate('coreWalletAdmin.dashboard.unprocessedIdDocuments')} />
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>Date</TableCell>
						<TableCell>File</TableCell>
						<TableCell>Qualifier</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{value.map(unprocessedIdDocument => (
						<TableRow className={classes.tableRow} key={unprocessedIdDocument.id} hover onClick={() => history.push(`/idDocuments/${unprocessedIdDocument.id}/show`)}>
							<TableCell>{toDisplayDateTimeFormat(unprocessedIdDocument.creationDateTime)}</TableCell>
							<TableCell>{unprocessedIdDocument.originalFileName}</TableCell>
							<TableCell>{unprocessedIdDocument.qualifier}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</Card>
	);
};

export default UnprocessedIdDocuments;
